export { PolicyPageComponent } from './policy-page.component';
export { PolicyPageModule } from './policy-page.module';
